import config from 'error-handler/config';
import sendError from 'error-handler/functions/sendError';
import middlewareAction from 'error-handler/middleware.action';
import { blockedClientErrorCode } from 'error-handler/helper/utils';

interface IMeta {
  Function?: string;
  Component?: string;
  Line?: number;
  Author?: string;
  errorInfo?: string;
}

const middleware = async (callback: Function, metaInfo?: IMeta): Promise<any> => {
  let result;
  try {
    result = await callback();
  } catch (err: any) {
    try {
      if (!blockedClientErrorCode(err))
        await sendError({ error: err, metaInfo: { ...metaInfo, errorInfo: `API middleware. ${metaInfo?.errorInfo}` } });
    } catch (err) {
      console.warn(`Error: error sending to admin \n ${err}`);
    }

    if (config.host === 'loc') alert(`ERROR MIDDLEWARE: ${err}`);
    middlewareAction();
  }
  return result;
};

export default middleware;
